import { io } from 'socket.io-client';
// ATPL live url
// const GMAIL_SOCKET_URL = 'https://app.applatus.com';
// const SOCKET_URL = 'https://app.applatus.com';
// Bu client  live url
const GMAIL_SOCKET_URL = 'https://api.bukingmaster.com';
const SOCKET_URL = 'https://api.bukingmaster.com';
// Local
// const SOCKET_URL = 'http://192.168.29.106:8889';
// const GMAIL_SOCKET_URL = 'http://192.168.29.106:3000';
const socket = io(SOCKET_URL, {
    path: '/socwh/socket.io',
    transports: ['websocket'],
    autoConnect: true,
});
const gmailSocket = io(GMAIL_SOCKET_URL, {
    path: '/socgm/socket.io',
    transports: ['websocket'],
    autoConnect: true,
});
export { socket, gmailSocket };
